// RTL Configuration
export const RTL_CONFIG = {
  languages: {
    en: {
      direction: 'ltr',
      textAlign: 'left',
      textAlignOpposite: 'right',
      marginStart: 'ml',
      marginEnd: 'mr',
      paddingStart: 'pl',
      paddingEnd: 'pr',
      borderStart: 'border-l',
      borderEnd: 'border-r',
      roundedStart: 'rounded-l',
      roundedEnd: 'rounded-r',
      flexDirection: 'flex-row',
      flexDirectionReverse: 'flex-row-reverse',
    },
    ar: {
      direction: 'rtl',
      textAlign: 'right',
      textAlignOpposite: 'left',
      marginStart: 'mr',
      marginEnd: 'ml',
      paddingStart: 'pr',
      paddingEnd: 'pl',
      borderStart: 'border-r',
      borderEnd: 'border-l',
      roundedStart: 'rounded-r',
      roundedEnd: 'rounded-l',
      flexDirection: 'flex-row-reverse',
      flexDirectionReverse: 'flex-row',
    }
  }
};

export const getRTLConfig = (language = 'en') => {
  return RTL_CONFIG.languages[language] || RTL_CONFIG.languages.en;
};

export const isRTL = (language = 'en') => {
  return language === 'ar';
};

export const getDirection = (language = 'en') => {
  return getRTLConfig(language).direction;
};

export const getTextAlign = (language = 'en') => {
  return getRTLConfig(language).textAlign;
};

export const getMarginStart = (language = 'en') => {
  return getRTLConfig(language).marginStart;
};

export const getMarginEnd = (language = 'en') => {
  return getRTLConfig(language).marginEnd;
};

export const getPaddingStart = (language = 'en') => {
  return getRTLConfig(language).paddingStart;
};

export const getPaddingEnd = (language = 'en') => {
  return getRTLConfig(language).paddingEnd;
};

export const getFlexDirection = (language = 'en') => {
  return getRTLConfig(language).flexDirection;
};

// Utility function to get RTL-aware classes
export const getRTLClasses = (language = 'en', baseClasses = '') => {
  const isRTLMode = isRTL(language);
  
  return `${baseClasses} ${isRTLMode ? 'rtl' : 'ltr'}`.trim();
};

// Utility function for conditional RTL classes
export const getConditionalRTLClass = (language = 'en', ltrClass = '', rtlClass = '') => {
  return isRTL(language) ? rtlClass : ltrClass;
};
